import { ref } from 'vue'
import { defineStore } from 'pinia'
import { minutesToMilliseconds } from 'date-fns'
import { cacheApi } from '../api/cache.api'

export const useCacheStore = defineStore('cache', () => {
  const timerId = ref<NodeJS.Timeout>()
  const hasApplicationSettingUpdate = ref<boolean>(false)
  const hasClientSettingUpdate = ref<boolean>(false)
  const hasUserUpdate = ref<boolean>(false)
  const lastUpdated = ref<Date>(new Date())

  const checkStatus = async (): Promise<void> => {
    const { data } = await cacheApi.checkStatus({ lastUpdated: lastUpdated.value })

    lastUpdated.value = new Date()

    if (!data) return

    hasApplicationSettingUpdate.value = data.hasApplicationSettingUpdate
    hasClientSettingUpdate.value = data.hasClientUpdate
    hasUserUpdate.value = data.hasUserUpdate
  }

  const clearCacheTimer = (): void => {
    if (!timerId.value) return

    clearTimeout(timerId.value)
  }

  const startCacheUpdate = (): void => {
    clearCacheTimer()

    timerId.value = setTimeout(() => {
      checkStatus()
      startCacheUpdate()
    }, minutesToMilliseconds(1))
  }

  return {
    hasApplicationSettingUpdate,
    hasClientSettingUpdate,
    hasUserUpdate,
    startCacheUpdate,
    clearCacheTimer,
  }
})
